<template>
    <span v-show="show">{{ amount }}</span>
    <small class="invalid-feedback d-block"
           v-show="error">
        {{ error || '' }}
    </small>
</template>

<script>
export default {
    props: {
        amount: {
            type: String,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
        show: {
            type: Boolean,
            required: true,
        }
    },
}
</script>

<style scoped>

</style>
